import React from 'react';
import { useFormikContext } from 'formik';
import AsyncSelect from "react-select/async";
import { StylesConfig } from 'react-select';

type Option = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  label: string;
};

type ComboBoxFormikProps = {
  name: string;
  label?: string;
  loadOptions: (inputValue: string) => Promise<Option[]>;
  className?: string;
  required?: boolean;
  valueProperty?: keyof Option;
  value?: Option;
  options?: Option[];
  defaultValue?: Option;
  onChange?: (value: Option | null) => void;
  placeholder?: string;
};

const inputStyles: StylesConfig<Option> = {
  control: (style) => ({ ...style, borderColor: '#616161', height: "42px" })
};

const AutocompleteAsyncFormik: React.FC<ComboBoxFormikProps> = ({ name, label, options, defaultValue, onChange, className, required, loadOptions, valueProperty, placeholder }) => {
  const { errors, setFieldValue } = useFormikContext<Record<string, unknown>>();
  return (
    <div className={`${className ? className : "h-20"}`}>
      <label htmlFor={name} className="block text-sm font-medium text-gray-600">
        {label || ''} {required && <b className="text-redPrimary">*</b>}
      </label>
      <AsyncSelect
        onChange={(item) => {
          setFieldValue(name, item || null);
          if (onChange) {
            onChange(item as Option);
          }
        }}
        cacheOptions
        defaultOptions={options}
        getOptionValue={(item) => valueProperty ? item[valueProperty] : item.value}
        getOptionLabel={(item) => item.label}
        loadOptions={loadOptions}
        styles={inputStyles}
        defaultValue={defaultValue}
        isClearable
        placeholder={placeholder}
      />
      {errors[name] && <small className="text-redPrimary/90" aria-live="polite">{errors[name] as string}</small>}
    </div>
  );
};

export default AutocompleteAsyncFormik;